module.exports = __webpack_public_path__ + "img/C.dd6b204d.png";